import React from "react"
import PropTypes from "prop-types"
import Modal from "react-modal"
import { transparentize } from "polished"

import theme from "styles/theme"

const customStyles = {
  content: {
    height: "100%",
    padding: "0",
    borderRadius: "0",
    border: "none",
    background: "transparent",
    zIndex: "102",
    overflow: "visible",
  },
  overlay: {
    zIndex: "101",
    backgroundColor: transparentize(0.2, theme.color.secondary01),
  },
}

const Lightbox = ({ showModal, handleCloseModal, children }) => {
  return (
    <>
      <Modal
        isOpen={showModal}
        style={customStyles}
        contentLabel="Project photographs"
        appElement={
          typeof document === "undefined"
            ? undefined
            : document.getElementById("___gatsby")
        }
        ariaHideApp
        shouldCloseOnOverlayClick
        onRequestClose={handleCloseModal}
      >
        {children}
      </Modal>
    </>
  )
}

Lightbox.propTypes = {
  showModal: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
}

export default Lightbox
